import React, {useEffect} from "react";
import CloseIcon from '@mui/icons-material/Close';

import './modal.css';


/* 
  Common Modal component which is used for all modal components
  < input = isOpen, onClose, title, showCustomContent, customContent > 
*/
function Modal({ isOpen, onClose, title, showCustomContent, customContent }) {
  
  // Function to close the modal when clicking outside of it
  useEffect(() => {
    
    const handleClickOutside = (event) => {
      if (isOpen && !event.target.closest(".modal-content")) {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, onClose]);
  
  return (
    <div className={`modal ${isOpen ? "" : "modal-hidden"}`}>
      <div className="modal-content">
        <div className="modal-header">
          <h2>
            {title}
            <span className="close" onClick={onClose}>
              {/* close button */}
              <CloseIcon />
            </span>
          </h2>
        </div>
        <div className="modal-body">{showCustomContent && customContent}</div>
      </div>
    </div>
  );
}

export default Modal;
